// Session-feature helpers for the Convorcher Session node's FEATURES field
// (ENG-875). The field stays a plain comma-separated string on data.features
// (blueprint schema unchanged); these helpers shape a checkbox UI over it.
//
// SESSION_FEATURES mirrors convorcher's UserFacingFeatures whitelist
// (app/lib/feature-flags/features.go) — the only tokens the server honors in
// the WS ?features= param; everything else is silently ignored server-side.
// There is no endpoint exposing the whitelist today, so this list is
// hand-mirrored: when convorcher adds a user-facing flag, add it here too.
export const SESSION_FEATURES = ['storyteller', 'suggestions', 'ttsaf', 'gesture_gen']

// parseFeatures — comma string → normalized token list (trimmed, lowercased,
// deduped, empties dropped). Matches the server's parse (ToLower + TrimSpace).
export function parseFeatures(str) {
  const seen = new Set()
  for (const part of String(str ?? '').split(',')) {
    const t = part.trim().toLowerCase()
    if (t) seen.add(t)
  }
  return [...seen]
}

export function hasFeature(str, feature) {
  return parseFeatures(str).includes(feature)
}

// toggleFeature — return the new comma string with `feature` added/removed.
// Unknown tokens are preserved verbatim in place (never silently dropped);
// an empty result is null so the field clears like the old text input did.
export function toggleFeature(str, feature, on) {
  const tokens = parseFeatures(str).filter((t) => t !== feature)
  if (on) tokens.push(feature)
  return tokens.length ? tokens.join(',') : null
}

// unknownFeatures — tokens present in the string that the server will ignore.
export function unknownFeatures(str) {
  return parseFeatures(str).filter((t) => !SESSION_FEATURES.includes(t))
}
